import { SelectOption } from "src/interfaces";
import moment from "moment-timezone";

export const getCallColor = (callerInfo: {
  eventType?: string;
  code?: string;
}) => {
  const type = callerInfo?.eventType;
  const code = callerInfo?.code;

  // Check type first
  switch (type) {
    case "call_inbound":
      return {
        main: "bg-blue-300",
        light: "bg-blue-200",
        iconBg: "bg-blue-100",
        iconColor: "text-blue-600",
      };
    case "call_outbound":
      return {
        main: "bg-[#00A441]",
        light: "bg-[#5DFF9E]",
        iconBg: "bg-[#5DFF9E]",
        iconColor: "text-[#00A441]",
      };
  }

  // If no type match, check code
  switch (code) {
    case "Answered":
      return {
        main: "bg-orange-300",
        light: "bg-orange-200",
        iconBg: "bg-orange-100",
        iconColor: "text-orange-500",
      };
    case "Disconnected":
      return {
        main: "bg-[#E0E0E0]",
        light: "bg-[#E0E0E0]",
        iconBg: "bg-[#E0E0E0]",
        iconColor: "text-[#939393]",
      };
  }

  // Default fallback
  return {
    main: "bg-blue-300",
    light: "bg-blue-200",
    iconBg: "bg-blue-100",
    iconColor: "text-blue-600",
  };
};

export const callTypeOptions: SelectOption[] = [
  { value: "answered", label: "Answered" },
  { value: "declined", label: "Declined" },
  { value: "missed", label: "Missed" },
  { value: "completed", label: "Completed" },
  { value: "dropped", label: "Dropped" },
];

export const outcomeOptions: SelectOption[] = [
  { value: "resolved", label: "Resolved" },
  { value: "follow-up", label: "Follow-up" },
  { value: "no-answer", label: "No Answer" },
  { value: "lead", label: "Lead" },
];
export const validEvents = ["call_inbound", "call_outbound"];
export const validCodes = ["Setup", "Proceeding", "Answered", "Disconnected"];

export const timeAgo = (dateTimeString: string) => {
  if (!dateTimeString) return "";

  const past = new Date(dateTimeString.replace(" ", "T")).getTime();
  const now = Date.now();

  const diffInSeconds = Math.floor((now - past) / 1000);

  if (diffInSeconds < 60) {
    return `${diffInSeconds}s ago`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes}m ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours}h ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  return `${diffInDays}d ago`;
};

export const userTimeZone = (time: any) => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const eventTimeLocal = moment.tz(time, "UTC").tz(userTimeZone);

  const now = moment();
  const diff = moment.duration(now.diff(eventTimeLocal));

  let customFromNow: any;
  if (diff.asSeconds() < 60) {
    customFromNow = `${Math.floor(diff.asSeconds())} seconds ago`;
  } else if (diff.asMinutes() < 60) {
    customFromNow = `${Math.floor(diff.asMinutes())} minutes ago`;
  } else if (diff.asHours() < 24) {
    customFromNow = `${Math.floor(diff.asHours())} hours ago`;
  } else {
    customFromNow = `${Math.floor(diff.asDays())} days ago`;
  }

  const formats = {
    time12h: eventTimeLocal.format("hh:mm A"),
    timeWithSeconds: eventTimeLocal.format("hh:mm:ss A"),
    dateTime: eventTimeLocal.format("MMM DD, hh:mm A"),
    fromNow: eventTimeLocal.fromNow(),
    customFromNow, // Custom formatted relative time
    fullDate: eventTimeLocal.format("YYYY-MM-DD HH:mm:ss"),

    // Additional formats
    logDateTime: eventTimeLocal.format("DD/MM/YYYY, HH:mm:ss"),
    createdDate: eventTimeLocal.format("DD-MM-YYYY"),
    updatedDate: eventTimeLocal.format("DD-MM-YYYY"),
  };

  return formats;
};
